import type { DashboardStats } from 'types';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';
import { config } from 'config';

export const useDashboard = (websiteId: number | undefined) => {
  const statisticsClient = useClient(config.STATISTICS_URL);
  const [timespan, setTimespan] = useState('alltime');

  const { data: dashboardStats, isLoading } = useQuery<DashboardStats>({
    queryKey: ['DASHBOARD', 'STATS', websiteId, timespan],
    queryFn: () => statisticsClient.get<DashboardStats>(`/dashboard/${websiteId}?timespan=${timespan}`),
    enabled: !!websiteId,
  });

  return { dashboardStats, isLoading, timespan, setTimespan, timespanOptions };
};

export type UseDashboardType = ReturnType<typeof useDashboard>;

const timespanOptions = [
  { value: 'alltime', label: 'All time' },
  { value: 'lastweek', label: 'Last week' },
  { value: 'lastmonth', label: 'Last month' },
  { value: 'lastyear', label: 'Last year' },
];
